var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import styles from './Table.module.scss';
import { Skeleton } from '../Skeleton/Skeleton';
import { BoxDanger } from '../../assets/icons';
import { EmptyState } from '../EmptyState/EmptyState';
import TableHeadCell from './components/TableHeadCell/TableHeadCell';
var Table = function (_a) {
    var titles = _a.titles, data = _a.data, cellWidth = _a.cellWidth, className = _a.className, rowClassName = _a.rowClassName, collapsible = _a.collapsible, _b = _a.skeletonRows, skeletonRows = _b === void 0 ? 10 : _b, id = _a.id, dataId = _a.dataId, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.emptyStateText, emptyStateText = _d === void 0 ? 'No results found for selected search parameters' : _d, onSort = _a.onSort;
    var renderHeaderCells = function (cells) { return (_jsx("tr", __assign({ className: "".concat(styles.TableRow) }, { children: cells.map(function (c) { return (_jsx(TableHeadCell, { data: c, onSort: onSort }, JSON.stringify(c))); }) }))); };
    var renderCells = function (cells) { return (_jsx("tr", __assign({ className: "".concat(styles.TableRow, " ").concat(rowClassName ? rowClassName : '') }, { children: cells.map(function (c, i) { return (_jsx("td", __assign({ className: "".concat(styles.TableCell, " ").concat(collapsible && !i ? styles.Collapse : '', " ").concat(c ? styles.ParentCell : ''), style: { minWidth: cellWidth ? cellWidth : 'auto' } }, { children: _jsx("div", __assign({ className: styles.TableHeadCell }, { children: c })) }), uuid())); }) }), uuid())); };
    var renderSkeleton = function (cells) {
        var rows = [];
        for (var index = 0; index < skeletonRows; index++) {
            var row = (_jsx("tr", __assign({ "data-testid": 'skeleton-row', className: "".concat(styles.TableRow, " ").concat(className ? className : '') }, { children: cells.map(function () { return (_jsx("td", __assign({ className: styles.SkeletonCell }, { children: _jsx(Skeleton, { variant: 'rounded', animation: 'wave', width: '95%', height: 25 }) }), uuid())); }) }), uuid()));
            rows.push(row);
        }
        return rows;
    };
    var renderData = function () { return data.map(function (dt) { return renderCells(dt); }); };
    return (_jsx("section", __assign({ "data-testid": 'table-component', id: id, className: "".concat(styles.TableWrapper, " ").concat(className ? className : '') }, { children: !isLoading && (data === null || data === void 0 ? void 0 : data.length) === 0 ? (_jsx(EmptyState, { title: emptyStateText, icon: _jsx(BoxDanger, {}), dataId: 'empty-state-component' })) : (_jsxs("table", __assign({ className: styles.Table, "data-testid": dataId }, { children: [_jsx("thead", __assign({ className: styles.TableHead }, { children: renderHeaderCells(titles) })), _jsx("tbody", { children: isLoading ? renderSkeleton(titles) : renderData() })] }))) })));
};
Table.propTypes = {
    className: PropTypes.string,
    rowClassName: PropTypes.string,
    cellWidth: PropTypes.number,
    collapsible: PropTypes.bool,
    isLoading: PropTypes.bool,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
export { Table };
//# sourceMappingURL=Table.js.map